import { View } from 'react-native';
import { Sidebar } from './sidebar';

interface DesktopSidebarProps {
  unreadCount?: number;
  onCheckIn: () => void;
}

export function DesktopSidebar({ unreadCount, onCheckIn }: DesktopSidebarProps) {
  return (
    <View
      style={{
        width: 280,
        paddingTop: 16,
        paddingBottom: 24,
      }}
    >
      <Sidebar unreadCount={unreadCount} onCheckIn={onCheckIn} />
    </View>
  );
}
